module.exports = {
	"api": 1,
	"kp": 8,
	"dev": {
		"host": "localhost",
		"wsPort": 8888,
		"wrtPort": 8001,
		"wsUrl": "ws://artschool.novodnestrovsk.arm.kodas.co.ua/ws/8",
		"baseUrl": "http://artschool.novodnestrovsk.arm.kodas.co.ua/api/v1"
	},
	"prod": {
		"wsUrl": "",
		"baseUrl": ""
	}
};


//////////////////
// WEBPACK FOOTER
// ./settings.json
// module id = 360
// module chunks = 0